import { Navigate } from "react-router-dom";
import { useGetSettingDetailsQuery } from "../api/pageBuilderApiSlice";
import BuilderLandingPage from "../features/websiteBuilder/BuilderLandingPage";
import { LoadingSpinner } from "../features/ui/LoadingSpinner";
import StyledText from "../components/StyledComponents/StyledText";
import { useTheme } from "../middleware/ThemeContext";

const WebsiteBuilderRedirect = () => {
    const { theme } = useTheme();
    const { data: company, isLoading } = useGetSettingDetailsQuery();

    if (isLoading) return (
        <div style={{ textAlign: "center", flex: 1, display: "flex", justifyContent: "center", alignItems: "center", height: 'calc(100vh - 100px)' }}>
            <div>
                <LoadingSpinner />
                <StyledText className="mt-4" fontSize="14px" fontWeight={600} textColor={theme.CreateFormTheme.colors.textSecondary}>Please wait while we load your data...</StyledText>
            </div>
        </div>
    );

    const canUseBuilder = company?.websiteCreated;

    if (canUseBuilder) {
        return <Navigate to="/home/builder" />;
    }

    return <BuilderLandingPage />;
};

export default WebsiteBuilderRedirect;
